import { useState, useEffect } from 'react';
import { get } from 'helpers/apiHelpers';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import {
  adminMailingOrder,
  clientMailingOrder,
  clientToggleable,
  mailingOptions,
} from './constans';
import MailNotificationView from './MailNotification.view';

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
const MailNotificationContainer = ({ t, user, brand }) => {
  const [state, setState] = useState({
    adminMailing: [],
    clientMailing: [],
    clientToggleableMailing: [],
    allowToChangedElements: false,
    mainEmailIsChanged: false,
  });

  useEffect(() => {
    // eslint-disable-next-line no-use-before-define -- FIXME
    fetchMailConfigurations();
    get(user.company, {
      properties: ['defaultConfigFromBrand'],
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    }).then(res => {
      setState(prev => ({
        ...prev,
        defaultConfigFromBrand: res.defaultConfigFromBrand,
      }));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, []);

  const sortMailing = (mailings, sort) =>
    mailings.sort((a, b) => {
      // eslint-disable-next-line radix -- FIXME
      const aVal = parseInt(
        Object.keys(sort).find(key => sort[key] === a.mailKey)
      );
      // eslint-disable-next-line radix -- FIXME
      const bVal = parseInt(
        Object.keys(sort).find(key => sort[key] === b.mailKey)
      );

      if (aVal === undefined || bVal === undefined) {
        return 1;
      }

      return aVal > bVal ? 1 : -1;
    });

  const setAllowToChangedElements = () => {
    setState(prev => ({
      ...prev,
      allowToChangedElements: !state.allowToChangedElements,
    }));
  };

  const fetchMailConfigurations = () => {
    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    get('mail-configurations').then(
      res => {
        const configurations = res['hydra:member'].map(configuration => ({
          ...configuration,
          hasChanged: false,
          isHidden: true,
          contentType:
            configuration.managedBySystem ||
            (configuration.enabledForOffice && !configuration.enabledForClient)
              ? 'office'
              : 'client',
        }));

        setState(prev => ({
          ...prev,
          adminMailing: sortMailing(
            configurations.filter(
              c => c.managedBySystem || c.mailKey === 'employee_welcome'
            ),
            adminMailingOrder
          ),
          clientMailing: sortMailing(
            configurations.filter(
              c => !c.managedBySystem && c.mailKey !== 'employee_welcome'
            ),
            clientMailingOrder
          ),
          clientToggleableMailing: configurations.filter(c =>
            clientToggleable.includes(c.mailKey)
          ),
        }));
      },
      () => toast.error(t('notify.cantGetCfg'))
    );
  };

  const props = {
    t,
    state,
    setState,
    mailingOptions,
    setAllowToChangedElements,
  };

  return <MailNotificationView props={props} />;
};

const mapStateToProps = state => ({
  brand: state.Auth.selectedBrand,
  user: state.Auth.user,
});

const enhance = compose(withTranslation(), connect(mapStateToProps, null));
export default enhance(MailNotificationContainer);
